import React, { useEffect, useState } from "react";
import OffCanvasMenuWms from "./offCanvasMenuWms";
import { HiMenu, HiOutlineX } from "react-icons/hi";
import { Link } from "react-scroll";

const Navbar_Wms = ({
  navDark,
  insurance,
  classOption,
  corporate,
  creativeAgencyOne,
  itCompany,
}) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);

  useEffect(() => {
    const stickyheader = document.querySelector(".main-header");
    if (stickyheader) {
      setHeaderTop(stickyheader.offsetTop);
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  const featureList = [
    { title: "Product Highlights", href: "productHighlights" },
    { title: "Capabilities", href: "capabilities" },
    { title: "Garage Controls", href: "garageControls" },
  ];

  return (
    <>
      <header
        className={`main-header z-10 border border-start-0 border-end-0 border-white
          ${creativeAgencyOne ? "creative_agency_nav " : ""}
          ${itCompany ? "it_company_nav " : ""}
          ${corporate ? "header-35 position-absolute top-0 start-0 zindex-9" : ""}
          ${navDark ? "position-absolute " : ""}
          w-100 ${classOption}
          ${insurance && "ins-header main-header w-100 z-10 "}
        `}
      >
        <nav
          className={`navbar navbar-expand-lg z-50
            ${corporate ? "affix" : ""}
            ${navDark ? "navbar-dark " : "navbar-light"}
            sticky-header ${scroll > headerTop ? "affix" : ""}
          `}
        >
          <div className="container d-flex align-items-center justify-content-lg-between position-relative">

            <img
              width={50}
              height={20}
              src="assets/logo/wms-logo-dark.png"
              alt="logo"
              className="navbar-toggler img-fluid logo-color"
              
            />
            {/* Hamburger button (mobile only) */}
            <button
              className="navbar-toggler position-absolute right-0 border-0"
              id="#offcanvasWithWms"
              role="button"
              
            >
              <span
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasWithWms"
              aria-controls="offcanvasWithWms">
              <HiMenu size={28} />
              </span>
            </button>

            {/* Desktop Navigation */}
            <div
              className="collapse navbar-collapse d-lg-flex"
              style={{ width: "100%" }}
            >
              <ul
                className="nav col-12 col-md-auto d-flex main-menu justify-content-evenly"
                style={{ width: "100%" }}
              >
                <li className="dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Features
                  </a>
                  <div className="dropdown-menu border-0 rounded-custom shadow py-0 bg-white">
                    <div className="dropdown-grid rounded-custom">
                      <div className="dropdown-grid-item">
                        {featureList.map((featureListItem, i) => (
                          <div key={i + 1} className="d-flex">
                            <Link
                              to={featureListItem.href}
                              smooth={true}
                              duration={600}
                              offset={-80}
                              className="nav-link text-muted"
                            >
                              {featureListItem.title}
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <Link
                    to="pricing"
                    smooth={true}
                    duration={600}
                    offset={-80}
                    className="nav-link cursor-pointer"
                  >
                    Pricing
                  </Link>
                </li>

                <li>
                  <Link>
                    {scroll > headerTop || !navDark || itCompany ? (
                      <img
                        width={50}
                        height={20}
                        src="assets/logo/wms-logo-dark.png"
                        alt="logo"
                        className="img-fluid logo-color"
                      />
                    ) : (
                      <img
                        width={80}
                        height={30}
                        src="assets/logo/wms-logo.png"
                        alt="logo"
                        style={{ height: "50px", width: "60px" }}
                      />
                    )}
                  </Link>
                </li>

                <li>
                  <a
                    href="https://wms.senertech.in/login"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-link"
                  >
                    Sign In
                  </a>
                </li>

                <li>
                  <a
                    href="https://wms.senertech.in/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-link"
                  >
                    Register
                  </a>
                </li>
              </ul>
            </div>

            {/* Offcanvas for Mobile */}
            <div
              className="offcanvas offcanvas-end d-lg-none"
              tabIndex="-1"
              id="offcanvasWithWms"
            >
              <div className="offcanvas-header d-flex align-items-center mt-4">
                <Link
                  to="/"
                  className="d-flex align-items-center mb-md-0 text-decoration-none"
                >
                  <img
                    width={121}
                    height={36}
                    src="/assets/logo/name-gold-blue-tb.png"
                    alt="logo"
                    className="img-fluid ps-2"
                  />
                </Link>
                <button
                  type="button"
                  className="close-btn text-danger"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <HiOutlineX size={24} />
                </button>
              </div>
              <OffCanvasMenuWms />
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar_Wms;
